import { render } from "./CalcInput.vue?vue&type=template&id=710b1ae4&scoped=true"
import script from "./CalcInput.vue?vue&type=script&lang=js"
export * from "./CalcInput.vue?vue&type=script&lang=js"

import "./CalcInput.vue?vue&type=style&index=0&id=710b1ae4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710b1ae4"]])

export default __exports__